import {z} from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {AssetSchema} from './asset'
import {PrimerComponentSectionIntroSchema} from './primerComponentSectionIntro'
import {PrimerCardsSchema} from './primerCards'
import {PrimerPillarsSchema} from './primerPillars'
import {FeaturedBentoSchema} from './featuredBento'
import {IntroStackedItemsSchema} from './introStackedItems'

export const FlexSectionVisualSettingsSchema = buildEntrySchemaFor('flexSectionVisualSettings', {
  fields: z.object({
    paddingBlockStart: z.enum(['none', 'normal', 'condensed', 'spacious']).optional(),
    paddingBlockEnd: z.enum(['none', 'normal', 'condensed', 'spacious']).optional(),
    backgroundColor: z.enum(['default', 'subtle']).optional(),
    backgroundImage: AssetSchema.optional(),
    backgroundImagePosition: z
      .enum(['left', 'right', 'top left', 'top right', 'bottom left', 'bottom right', 'center', 'top', 'bottom'])
      .optional(),
    backgroundImageSize: z.enum(['cover', 'contain']).optional(),
    roundedCorners: z.boolean().optional(),
    verticalGap: z.enum(['normal', 'spacious']).optional(),
  }),
})

export const FlexSectionSchema = buildEntrySchemaFor('flexSection', {
  fields: z.object({
    id: z.string().optional(),
    introStackedItems: IntroStackedItemsSchema.optional(),
    sectionIntro: PrimerComponentSectionIntroSchema.optional(),
    pillars: PrimerPillarsSchema.optional(),
    cards: PrimerCardsSchema.optional(),
    featuredBento: FeaturedBentoSchema.optional(),
    visualSettings: FlexSectionVisualSettingsSchema.optional(),
  }),
})

export type FlexSection = z.infer<typeof FlexSectionSchema>
